import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Button, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
// import TrackPackage from "../../../Shared/TrackPackage";

const OrderItem = (props) => {
  const navigate = useNavigate();
  const {
    orderItemDetails: { orderItems = [], status = "" } = {},
    orderNumber = "",
  localDate=''
  } = props;
  const {
    brand = "",
    imageUrl = "",
    name = "",
    sku = "",
  } = orderItems[0] || {};

  /* const [open, setOpen] = useState(false); */
  const routeToReview = () => {
    navigate(`/product/review?orderId=${orderNumber}`);
  };
  const StyledButton = styled.button`
  
  border:none;
  width:121px;
  height:35px;
  display:flex;
  justify-content:center;
  align-items:center;
  background-color:#f1f1f1;
  color:#222;
  margin-top:1rem;
  cursor:pointer;

  `

  return (
    <React.Fragment>
      <Grid container spacing={3} sx={{ mb: 1, mt: 1 }} style={{padding:'1rem 2rem'}}> 
        <Grid xs={12}>
       <div style={{display:'flex'}}>
           <Typography variant="body" component="div" style={{backgroundColor:'#197d4d',color:'#fff',maxWidth:111,padding:'.6rem 1rem',borderRadius:'1rem',fontSize:'.8rem',display:'flex',justifyContent:'center'}}>
             {status || "Ordered"}
          </Typography>
            <Typography variant="body" component="div" style={{backgroundColor:'#fff',color:'#555',maxWidth:211,padding:'.6rem 1rem',borderRadius:'1rem',fontSize:'.8rem',display:'flex',justifyContent:'center',marginLeft:'.4rem'}}>
             {localDate}
          </Typography>
       </div>

        </Grid>
        <Grid xs={3}>
          <Link to={`/pd/${sku}`}>
            <img src={imageUrl} alt="delivery_img" style={{borderRadius:'.5rem'}} height={100} width={100} />
          </Link>
        </Grid>
        <Grid xs={5}>
          <Link to={`/pd/${sku}`} className="route-link">
            <Typography variant="body" component="div" fontWeight={500} style={{color:'#222',fontSize:'.9rem'}}>
              {`${brand} ${name}`}
            </Typography>
          </Link>
             <StyledButton onClick={routeToReview}>
                review
            </StyledButton>
        </Grid>
         <Link
                to={`${"/myaccount/orderDetails"}?orderId=${orderNumber}`}
                className="route-link"
                style={{ paddingRight: "10px" }}
              >
                View order details
              </Link>
        <Grid xs={3}>
          <Grid container spacing={2} direction={"column"} gap={2}>
            {/* <Button variant="outlined">Track package</Button> */}
         
          </Grid>
        </Grid>
        {/* <Grid>
              <TrackPackage
                open={open}
                setOpen={setOpen}
                shipmentEvents={shipmentEvents}
              />
            </Grid> */}
      </Grid>
    </React.Fragment>
  );
};

export default OrderItem;
